module.exports = "/static/assets/87924d6354694a1b40c4404b39f783d7.png";